"use client";

import { TrendingUp, TrendingDown, Minus, RefreshCw } from "lucide-react";
import { useState } from "react";

const metalRates = [
  {
    id: "gold_24k",
    label: "Gold 24K",
    sublabel: "999 purity · per gram",
    value: 7842,
    prevValue: 7819,
    change: +23,
    changePct: +0.29,
    unit: "₹/g",
    color: "gold",
    bgClass: "from-gold-50 to-amber-50",
    borderClass: "border-gold-200",
    iconBg: "bg-gold-100",
    iconColor: "text-gold-600",
    mcxRef: 7831,
  },
  {
    id: "gold_22k",
    label: "Gold 22K",
    sublabel: "916 purity · per gram",
    value: 7185,
    prevValue: 7164,
    change: +21,
    changePct: +0.29,
    unit: "₹/g",
    color: "gold",
    bgClass: "from-yellow-50 to-gold-50",
    borderClass: "border-yellow-200",
    iconBg: "bg-yellow-100",
    iconColor: "text-yellow-700",
    mcxRef: 7178,
  },
  {
    id: "silver",
    label: "Silver",
    sublabel: "999 purity · per gram",
    value: 94.5,
    prevValue: 94.62,
    change: -0.12,
    changePct: -0.13,
    unit: "₹/g",
    color: "silver",
    bgClass: "from-slate-50 to-gray-50",
    borderClass: "border-slate-200",
    iconBg: "bg-slate-100",
    iconColor: "text-slate-500",
    mcxRef: 94.2,
  },
  {
    id: "platinum",
    label: "Platinum",
    sublabel: "950 purity · per gram",
    value: 3210,
    prevValue: 3194,
    change: +16,
    changePct: +0.5,
    unit: "₹/g",
    color: "platinum",
    bgClass: "from-indigo-50 to-purple-50",
    borderClass: "border-indigo-200",
    iconBg: "bg-indigo-100",
    iconColor: "text-indigo-500",
    mcxRef: 3205,
  },
];

function MetalIcon({ id }: { id: string }) {
  const icons: Record<string, string> = {
    gold_24k: "Au",
    gold_22k: "Au",
    silver: "Ag",
    platinum: "Pt",
  };
  return (
    <span data-component-id="src/app/homepage/components/HeroRateCards.tsx:81:4" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="81" data-component-end-line="81" data-component-file="HeroRateCards.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-mono%20text-sm%20font-700%22%7D" className="font-mono text-sm font-700">{icons[id] || "·"}</span>
  );
}

export default function HeroRateCards() {
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = () => {
    setRefreshing(true);
    setTimeout(() => setRefreshing(false), 1200);
  };

  return (
    <div data-component-id="src/app/homepage/components/HeroRateCards.tsx:94:4" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="94" data-component-end-line="211" data-component-file="HeroRateCards.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
      <div data-component-id="src/app/homepage/components/HeroRateCards.tsx:95:6" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="95" data-component-end-line="109" data-component-file="HeroRateCards.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-between%20mb-4%22%7D" className="flex items-center justify-between mb-4">
        <p data-component-id="src/app/homepage/components/HeroRateCards.tsx:96:8" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="96" data-component-end-line="98" data-component-file="HeroRateCards.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-muted-foreground%22%2C%22textContent%22%3A%22MCX%20reference%20rates%20shown%20alongside%20Delhi%20market%20rates%22%7D" className="text-sm text-muted-foreground">
          MCX reference rates shown alongside Delhi market rates
        </p>
        <button data-component-id="src/app/homepage/components/HeroRateCards.tsx:99:8" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="99" data-component-end-line="108" data-component-file="HeroRateCards.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22flex%20items-center%20gap-1.5%20text-xs%20text-muted-foreground%20hover%3Atext-gold-500%20transition-colors%20px-3%20py-1.5%20rounded-lg%20hover%3Abg-gold-50%22%2C%22textContent%22%3A%22Refresh%20Rates%22%7D"
          onClick={handleRefresh}
          className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-gold-500 transition-colors px-3 py-1.5 rounded-lg hover:bg-gold-50"
        >
          <RefreshCw data-component-id="src/app/homepage/components/HeroRateCards.tsx:103:10" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="103" data-component-end-line="106" data-component-file="HeroRateCards.tsx" data-component-name="RefreshCw" data-component-content="%7B%22elementName%22%3A%22RefreshCw%22%7D"
            size={13}
            className={refreshing ? "animate-spin" : ""}
          />
          Refresh Rates
        </button>
      </div>

      {/* Metal cards */}
      <div data-component-id="src/app/homepage/components/HeroRateCards.tsx:112:6" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="112" data-component-end-line="210" data-component-file="HeroRateCards.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-3%20xl%3Agrid-cols-4%20gap-4%22%7D" className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-4">
        {metalRates.map((metal, idx) => {
          const isUp = metal.change > 0;
          const isDown = metal.change < 0;
          const isFlat = metal.change === 0;

          return (
            <div data-component-id="src/app/homepage/components/HeroRateCards.tsx:119:12" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="119" data-component-end-line="207" data-component-file="HeroRateCards.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              key={metal.id}
              className={`card-hover bg-gradient-to-br ${metal.bgClass} border ${metal.borderClass} rounded-xl p-4 cursor-pointer animate-fade-in ${
                ""
              }`}
              style={{ animationDelay: `${idx * 60}ms` }}
            >
              {/* Header */}
              <div data-component-id="src/app/homepage/components/HeroRateCards.tsx:127:14" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="127" data-component-end-line="151" data-component-file="HeroRateCards.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20justify-between%20mb-3%22%7D" className="flex items-start justify-between mb-3">
                <div data-component-id="src/app/homepage/components/HeroRateCards.tsx:128:16" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="128" data-component-end-line="132" data-component-file="HeroRateCards.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                  className={`w-9 h-9 rounded-lg ${metal.iconBg} ${metal.iconColor} flex items-center justify-center`}
                >
                  <MetalIcon data-component-id="src/app/homepage/components/HeroRateCards.tsx:131:18" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="131" data-component-end-line="131" data-component-file="HeroRateCards.tsx" data-component-name="MetalIcon" data-component-content="%7B%22elementName%22%3A%22MetalIcon%22%7D" id={metal.id} />
                </div>
                {isUp && (
                  <span data-component-id="src/app/homepage/components/HeroRateCards.tsx:134:18" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="134" data-component-end-line="137" data-component-file="HeroRateCards.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22ticker-badge%20ticker-up%22%2C%22textContent%22%3A%22%2B%20%25%22%7D" className="ticker-badge ticker-up">
                    <TrendingUp data-component-id="src/app/homepage/components/HeroRateCards.tsx:135:20" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="135" data-component-end-line="135" data-component-file="HeroRateCards.tsx" data-component-name="TrendingUp" data-component-content="%7B%22elementName%22%3A%22TrendingUp%22%7D" size={11} />
                    +{metal.changePct.toFixed(2)}%
                  </span>
                )}
                {isDown && (
                  <span data-component-id="src/app/homepage/components/HeroRateCards.tsx:140:18" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="140" data-component-end-line="143" data-component-file="HeroRateCards.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22ticker-badge%20ticker-down%22%2C%22textContent%22%3A%22%25%22%7D" className="ticker-badge ticker-down">
                    <TrendingDown data-component-id="src/app/homepage/components/HeroRateCards.tsx:141:20" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="141" data-component-end-line="141" data-component-file="HeroRateCards.tsx" data-component-name="TrendingDown" data-component-content="%7B%22elementName%22%3A%22TrendingDown%22%7D" size={11} />
                    {metal.changePct.toFixed(2)}%
                  </span>
                )}
                {isFlat && (
                  <span data-component-id="src/app/homepage/components/HeroRateCards.tsx:146:18" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="146" data-component-end-line="149" data-component-file="HeroRateCards.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22ticker-badge%20ticker-neutral%22%2C%22textContent%22%3A%220.00%25%22%7D" className="ticker-badge ticker-neutral">
                    <Minus data-component-id="src/app/homepage/components/HeroRateCards.tsx:147:20" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="147" data-component-end-line="147" data-component-file="HeroRateCards.tsx" data-component-name="Minus" data-component-content="%7B%22elementName%22%3A%22Minus%22%7D" size={11} />
                    0.00%
                  </span>
                )}
              </div>

              {/* Label */}
              <p data-component-id="src/app/homepage/components/HeroRateCards.tsx:154:14" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="154" data-component-end-line="156" data-component-file="HeroRateCards.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20font-600%20text-slate-500%20uppercase%20tracking-wide%20mb-0.5%22%7D" className="text-xs font-600 text-slate-500 uppercase tracking-wide mb-0.5">
                {metal.label}
              </p>
              <p data-component-id="src/app/homepage/components/HeroRateCards.tsx:157:14" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="157" data-component-end-line="157" data-component-file="HeroRateCards.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B10px%5D%20text-slate-400%20mb-2%22%7D" className="text-[10px] text-slate-400 mb-2">{metal.sublabel}</p>

              {/* Value */}
              <p data-component-id="src/app/homepage/components/HeroRateCards.tsx:160:14" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="160" data-component-end-line="171" data-component-file="HeroRateCards.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%7D"
                className={`price-value text-2xl font-700 ${
                  isUp
                    ? "text-slate-900"
                    : isDown
                    ? "text-red-700" :"text-slate-900"
                }`}
              >
                {metal.value < 1000
                  ? `₹${metal.value.toFixed(2)}`
                  : `₹${metal.value.toLocaleString("en-IN")}`}
              </p>
              <p data-component-id="src/app/homepage/components/HeroRateCards.tsx:172:14" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="172" data-component-end-line="174" data-component-file="HeroRateCards.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B10px%5D%20text-slate-400%20font-mono%20mt-0.5%22%7D" className="text-[10px] text-slate-400 font-mono mt-0.5">
                {metal.unit}
              </p>

              {/* Change */}
              {!isFlat && (
                <p data-component-id="src/app/homepage/components/HeroRateCards.tsx:178:16" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="178" data-component-end-line="188" data-component-file="HeroRateCards.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22textContent%22%3A%22from%20yesterday%22%7D"
                  className={`text-xs font-mono mt-1.5 ${
                    isUp ? "text-green-600" : "text-red-600"
                  }`}
                >
                  {isUp ? "+" : ""}
                  {metal.change < 1 && metal.change > -1
                    ? metal.change.toFixed(2)
                    : metal.change.toLocaleString("en-IN")}{" "}
                  from yesterday
                </p>
              )}
              {isFlat && (
                <p data-component-id="src/app/homepage/components/HeroRateCards.tsx:191:16" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="191" data-component-end-line="193" data-component-file="HeroRateCards.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20font-mono%20mt-1.5%20text-slate-400%22%2C%22textContent%22%3A%22Unchanged%20from%20yesterday%22%7D" className="text-xs font-mono mt-1.5 text-slate-400">
                  Unchanged from yesterday
                </p>
              )}

              {/* MCX ref */}
              {metal.mcxRef && (
                <div data-component-id="src/app/homepage/components/HeroRateCards.tsx:198:16" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="198" data-component-end-line="205" data-component-file="HeroRateCards.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-2.5%20pt-2.5%20border-t%20border-white%2F60%22%7D" className="mt-2.5 pt-2.5 border-t border-white/60">
                  <p data-component-id="src/app/homepage/components/HeroRateCards.tsx:199:18" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="199" data-component-end-line="204" data-component-file="HeroRateCards.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-%5B10px%5D%20text-slate-400%22%2C%22textContent%22%3A%22MCX%20Ref%3A%22%7D" className="text-[10px] text-slate-400">
                    MCX Ref:{" "}
                    <span data-component-id="src/app/homepage/components/HeroRateCards.tsx:201:20" data-component-path="src/app/homepage/components/HeroRateCards.tsx" data-component-line="201" data-component-end-line="203" data-component-file="HeroRateCards.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-mono%20font-500%20text-slate-500%22%2C%22textContent%22%3A%22%E2%82%B9%20%2Fg%22%7D" className="font-mono font-500 text-slate-500">
                      ₹{metal.mcxRef.toLocaleString("en-IN")}/g
                    </span>
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}